//const BASE_URL = `${window.location.origin.split(':')[0]}:${window.location.origin.split(':')[1]}:8000`;
import { apiRequest, BASE_URL } from './base';


export async function login(credentials) {
  const formData = new URLSearchParams();
  formData.append('username', credentials.email);
  formData.append('password', credentials.password);

  const response = await fetch(`${BASE_URL}/token`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded',
    },
    body: formData,
  });

  if (!response.ok) {
    if (response.status === 401) {
      throw new Error('Incorrect email or password');
    }
    throw new Error('Login failed');
  }

  const data = await response.json();

  return {
    token: data.access_token,
    tokenType: data.token_type
  };
}

export async function signUp(credentials) {
  const data = await apiRequest('/signup', 'POST', {
    email: credentials.email,
    password: credentials.password,
    name: credentials.name
  });
  return {
    token: data.access_token,
    tokenType: data.token_type
  };
}

export async function apiResetPassword(currentPassword, newPassword) {
  return apiRequest('/reset-password', 'POST', { current_password: currentPassword, new_password: newPassword });
}

export async function apiForgotPassword(email) {
  return apiRequest('/forgot-password', 'POST', null, { email:email });
}

export const fetchPermissions = async (siteId) => {
  return apiRequest(`/site-user-permissions/${siteId}`);
}

export const fetchUserSites = async (filter_inactive = true) => {
  return apiRequest('/user-sites', 'GET', null, { filter_inactive: filter_inactive });
}

export const updateUser = async (userId, name=null, email=null, password=null) => {
  return apiRequest(`/users/${userId}`, 'PUT', { name: name, email: email, password: password });
}
